import ko from 'knockout';
import $ from 'jquery';
import _ from 'lodash';
import templateMarkup from 'raw-loader!./image-capture-widget.html';

function ImageCaptureWidget(params) {
    var self = this;

    self.exportType = params.type;
    self.pageId = params.pageId;
    self.panelId = params.panelId;
    self.queryParamsObs = params.queryParams;
    self.reportElements = params.reportElements;
    self.useDropdownStyle = params.useDropdownStyle;

    self.enableExport = _.get(params, 'enable', ko.observable(true)); // default to enable

    self.exportImage = function (data, event) {
        if ($(event.target.parentElement).hasClass('disabled')) {
            return;
        }
        setTimeout(function () {
            self.captureImage(event);
        }, 0);
    };
}

ImageCaptureWidget.prototype = {
    captureImage: function () {
        var self = this;
        $('.tooltip').hide();

        $("#ExportModal").modal('show');

        var exportVm = ko.dataFor($("#ExportModal")[0]);

        exportVm.initialize(
            self.exportType,
            'export',
            'image',
            self.pageId,
            self.panelId,
            self.pageId,
            self.queryParamsObs ? self.queryParamsObs() : {},
            self.reportElements);

        exportVm.execute();
    }
};

export default { viewModel: ImageCaptureWidget, template: templateMarkup };
